// src/core/components/brandMarkGlyph.ts
// Written by scripts/build-mark.js from scripts/rune-glyph.js. Do not edit.

/** The rune ᛗ inside BrandMark's 28-unit square, as an SVG path. */
export const BRAND_MARK_GLYPH =
  "M7.64 6.5L10.24 6.5L10.24 21.5L7.64 21.5ZM17.76 6.5L20.36 6.5L20.36 21.5L17.76 21.5ZM8.94 6.5L10.24 6.5L17.76 14.21L19.06 15.54L19.06 18.59L8.94 8.22ZM17.76 6.5L19.06 6.5L19.06 8.22L8.94 18.59L8.94 15.54L10.24 14.21Z";
